import { Injectable } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  showLoader: BehaviorSubject<{ show:boolean, message : string}> = new BehaviorSubject<{ show:boolean, message : string}>({ show:false, message : ''})
  constructor(
    private notifier : NotifierService
  ) { }

  show(message : string){
    this.showLoader.next({show : true, message : message})
  }

  hide() {
    this.showLoader.next({show:false, message : ''});
  }

publishMessage(style : string, content : string) {
  this.notifier.notify(style, content)
  setTimeout(()=> {
    this.dismissMessage()
  }, 10000)
}

dismissMessage() {
  this.notifier.hideAll()
}

}
